import { useState } from 'react'
import { Search, Plus, Pencil, CheckCircle2, Trash2, XCircle, Eye, Download, Printer, FileText, Clock } from 'lucide-react'
import { Modal, ConfirmModal } from '../common/Modal'

const INVOICES = [
  {
    id: 'INV-2025-001', client: 'Acme Corporation', email: 'billing@acme.com',
    amount: 4800.00, tax: 864.00, total: 5664.00, status: 'paid',
    date: 'May 1, 2025', due: 'May 15, 2025',
    items: [
      { desc: 'UI/UX Design', qty: 40, rate: 80, amount: 3200 },
      { desc: 'Frontend Dev', qty: 20, rate: 80, amount: 1600 },
    ],
    projectId: 'PRJ-2025-011', projectName: 'Acme Dashboard Redesign', projectManager: 'Rahul Sharma',
    projectCategory: 'Web Development', startDate: 'Apr 1, 2025', endDate: 'May 1, 2025',
    currency: 'INR', paymentTerms: 'Net 15', paymentMode: 'NEFT', bankAccount: 'HDFC ···4321',
    ifsc: 'HDFC0001234', gstNumber: '24AABCN1234A1Z5', poNumber: 'PO-ACME-2025-04',
    deliverables: ['Wireframes', 'UI Design', 'Frontend Code', 'Documentation'],
    milestones: [
      { name: 'Discovery & Wireframe', pct: 100, amount: 1200 },
      { name: 'UI Design', pct: 100, amount: 1600 },
      { name: 'Development', pct: 100, amount: 2000 },
    ],
    clientContact: 'John Smith', clientPhone: '+91 98765 43210',
    clientAddress: '123, Business Park, Mumbai - 400001',
    notes: 'All deliverables submitted and approved by client.', discount: 0, subtotal: 4800,
  },
  {
    id: 'INV-2025-002', client: 'TechFlow Inc.', email: 'finance@techflow.io',
    amount: 2200.00, tax: 396.00, total: 2596.00, status: 'pending',
    date: 'May 3, 2025', due: 'May 17, 2025',
    items: [{ desc: 'API Integration', qty: 22, rate: 100, amount: 2200 }],
    projectId: 'PRJ-2025-012', projectName: 'TechFlow Payment Gateway', projectManager: 'Priya Mehta',
    projectCategory: 'Backend Development', startDate: 'Apr 15, 2025', endDate: 'May 17, 2025',
    currency: 'INR', paymentTerms: 'Net 14', paymentMode: 'NEFT', bankAccount: 'SBI ···8821',
    ifsc: 'SBIN0001122', gstNumber: '24AABCN1234A1Z5', poNumber: 'PO-TF-2025-09',
    deliverables: ['API Documentation', 'Integration Code', 'Testing Report'],
    milestones: [
      { name: 'API Design', pct: 100, amount: 600 },
      { name: 'Integration', pct: 80, amount: 1100 },
      { name: 'Testing & QA', pct: 40, amount: 500 },
    ],
    clientContact: 'Amit Joshi', clientPhone: '+91 87654 32109',
    clientAddress: '45, Tech Hub, Bangalore - 560001',
    notes: 'Phase 2 integration pending client approval.', discount: 0, subtotal: 2200,
  },
  {
    id: 'INV-2025-003', client: 'DesignStudio EU', email: 'hello@design.eu',
    amount: 1500.00, tax: 270.00, total: 1770.00, status: 'overdue',
    date: 'Apr 10, 2025', due: 'Apr 24, 2025',
    items: [{ desc: 'Brand Identity', qty: 1, rate: 1500, amount: 1500 }],
    projectId: 'PRJ-2025-008', projectName: 'DesignStudio Brand Kit', projectManager: 'Anjali Verma',
    projectCategory: 'Branding & Design', startDate: 'Mar 20, 2025', endDate: 'Apr 10, 2025',
    currency: 'EUR', paymentTerms: 'Net 14', paymentMode: 'SWIFT', bankAccount: 'ICICI ···1122',
    ifsc: 'ICIC0002233', gstNumber: '24AABCN1234A1Z5', poNumber: 'PO-DSE-2025-02',
    deliverables: ['Logo Files', 'Brand Guidelines PDF', 'Color Palette', 'Typography Guide'],
    milestones: [
      { name: 'Research & Moodboard', pct: 100, amount: 300 },
      { name: 'Logo Design', pct: 100, amount: 700 },
      { name: 'Brand Guidelines', pct: 100, amount: 500 },
    ],
    clientContact: 'Sophie Müller', clientPhone: '+49 170 1234567',
    clientAddress: 'Hauptstraße 12, Berlin 10115, Germany',
    notes: 'Payment overdue. Follow up required.', discount: 0, subtotal: 1500,
  },
  {
    id: 'INV-2025-004', client: 'StartupHub', email: 'ops@startuphub.co',
    amount: 6300.00, tax: 1134.00, total: 7434.00, status: 'paid',
    date: 'Apr 20, 2025', due: 'May 4, 2025',
    items: [{ desc: 'Full-Stack Dev', qty: 63, rate: 100, amount: 6300 }],
    projectId: 'PRJ-2025-005', projectName: 'StartupHub Platform v2', projectManager: 'Karan Patel',
    projectCategory: 'Full-Stack Development', startDate: 'Mar 1, 2025', endDate: 'Apr 20, 2025',
    currency: 'INR', paymentTerms: 'Net 14', paymentMode: 'NEFT', bankAccount: 'HDFC ···9910',
    ifsc: 'HDFC0005566', gstNumber: '24AABCN1234A1Z5', poNumber: 'PO-SH-2025-01',
    deliverables: ['Backend APIs', 'Frontend App', 'Admin Panel', 'Deployment'],
    milestones: [
      { name: 'Architecture', pct: 100, amount: 1200 },
      { name: 'Backend Dev', pct: 100, amount: 2100 },
      { name: 'Frontend Dev', pct: 100, amount: 2000 },
      { name: 'Deployment & QA', pct: 100, amount: 1000 },
    ],
    clientContact: 'Neha Kapoor', clientPhone: '+91 99887 76654',
    clientAddress: '88, Innovation Centre, Pune - 411001',
    notes: 'Successfully delivered. Client very satisfied.', discount: 200, subtotal: 6300,
  },
  {
    id: 'INV-2025-005', client: 'HealthPlus India', email: 'billing@healthplus.in',
    amount: 900.00, tax: 162.00, total: 1062.00, status: 'draft',
    date: 'May 6, 2025', due: 'May 20, 2025',
    items: [{ desc: 'Consultation', qty: 6, rate: 150, amount: 900 }],
    projectId: 'PRJ-2025-016', projectName: 'HealthPlus App Consultation', projectManager: 'Sneha Joshi',
    projectCategory: 'Consulting', startDate: 'May 6, 2025', endDate: 'May 20, 2025',
    currency: 'INR', paymentTerms: 'Net 14', paymentMode: 'UPI', bankAccount: 'Axis ···4477',
    ifsc: 'UTIB0003344', gstNumber: '24AABCN1234A1Z5', poNumber: '',
    deliverables: ['Tech Audit Report', 'Recommendations Doc'],
    milestones: [
      { name: 'Initial Consultation', pct: 60, amount: 540 },
      { name: 'Final Report', pct: 0, amount: 360 },
    ],
    clientContact: 'Dr. Suresh Rao', clientPhone: '+91 94455 66778',
    clientAddress: '12, Medical Complex, Hyderabad - 500001',
    notes: 'Draft invoice. Not yet sent to client.', discount: 0, subtotal: 900,
  },
  {
    id: 'INV-2025-006', client: 'Global Retail Ltd.', email: 'ap@globalretail.com',
    amount: 3400.00, tax: 612.00, total: 4012.00, status: 'pending',
    date: 'May 5, 2025', due: 'May 19, 2025',
    items: [{ desc: 'E-commerce Dev', qty: 34, rate: 100, amount: 3400 }],
    projectId: 'PRJ-2025-014', projectName: 'Global Retail E-Commerce Store', projectManager: 'Mohit Rathod',
    projectCategory: 'E-Commerce', startDate: 'Apr 10, 2025', endDate: 'May 19, 2025',
    currency: 'INR', paymentTerms: 'Net 14', paymentMode: 'NEFT', bankAccount: 'BOB ···6655',
    ifsc: 'BARB0007788', gstNumber: '24AABCN1234A1Z5', poNumber: 'PO-GRL-2025-07',
    deliverables: ['Product Catalog', 'Cart & Checkout', 'Payment Integration', 'CMS'],
    milestones: [
      { name: 'Design & Prototype', pct: 100, amount: 800 },
      { name: 'Product Module', pct: 100, amount: 1100 },
      { name: 'Checkout & Payment', pct: 70, amount: 900 },
      { name: 'CMS & Launch', pct: 10, amount: 600 },
    ],
    clientContact: 'Ramesh Gupta', clientPhone: '+91 93344 55667',
    clientAddress: '56, Commerce House, Delhi - 110001',
    notes: 'Checkout module in progress.', discount: 100, subtotal: 3400,
  },
]

const STATUS_META = {
  paid: { color: '#10B981', bg: 'rgba(16,185,129,0.12)', border: 'rgba(16,185,129,0.30)', label: 'Paid', Icon: CheckCircle2 },
  pending: { color: '#F59E0B', bg: 'rgba(245,158,11,0.12)', border: 'rgba(245,158,11,0.30)', label: 'Pending', Icon: Clock },
  overdue: { color: '#EF4444', bg: 'rgba(239,68,68,0.12)', border: 'rgba(239,68,68,0.30)', label: 'Overdue', Icon: XCircle },
  draft: { color: '#6366F1', bg: 'rgba(99,102,241,0.12)', border: 'rgba(99,102,241,0.30)', label: 'Draft', Icon: FileText },
}

const fmt = n => '₹' + Number(n).toLocaleString('en-IN')
const fmtDate = d => { if (!d) return '—'; const dt = new Date(d); return dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) }
const today = () => new Date().toISOString().split('T')[0]
const rupee = n => `₹${Number(n).toLocaleString('en-IN')}`
const formatCurrency = (n, currency = 'INR') => {
  if (currency === 'EUR') return `€${Number(n).toLocaleString('en-EU')}`
  if (currency === 'USD') return `$${Number(n).toLocaleString('en-US')}`
  return rupee(n)
}

/* ─── Build self-contained invoice HTML ─── */
function buildInvoiceHTML(inv) {
  const fc = (n) => formatCurrency(n, inv.currency)
  const statusColor = { paid: '#10B981', pending: '#F59E0B', overdue: '#EF4444', draft: '#6366F1' }[inv.status] || '#6366F1'
  const statusBg = { paid: 'rgba(16,185,129,0.15)', pending: 'rgba(245,158,11,0.15)', overdue: 'rgba(239,68,68,0.15)', draft: 'rgba(99,102,241,0.15)' }[inv.status] || 'rgba(99,102,241,0.15)'
  const statusLabel = { paid: 'Paid', pending: 'Pending', overdue: 'Overdue', draft: 'Draft' }[inv.status] || 'Draft'
  const todayStr = new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })

  const itemRows = (inv.items || []).map((item, i) => `
    <tr>
      <td style="padding:11px 14px;font-size:12px;color:#6D7AA5;border-bottom:1px solid #e4e8f4;width:36px">${i + 1}</td>
      <td style="padding:11px 14px;font-size:13px;color:#0D1530;border-bottom:1px solid #e4e8f4;font-weight:500">${item.desc}</td>
      <td style="padding:11px 14px;font-size:12px;color:#3D4A73;border-bottom:1px solid #e4e8f4;text-align:right;font-family:'Courier New',monospace">${item.qty}</td>
      <td style="padding:11px 14px;font-size:12px;color:#3D4A73;border-bottom:1px solid #e4e8f4;text-align:right;font-family:'Courier New',monospace">${fc(item.rate)}</td>
      <td style="padding:11px 14px;font-size:13px;color:#0D1530;border-bottom:1px solid #e4e8f4;text-align:right;font-weight:700;font-family:'Courier New',monospace">${fc(item.amount)}</td>
    </tr>`).join('')

  const discountRow = inv.discount > 0
    ? `<div style="display:flex;justify-content:space-between;padding:7px 0;font-size:12px;color:#3D4A73;border-bottom:1px solid #e4e8f4"><span>Discount</span><span style="font-family:'Courier New',monospace;color:#dc2626">− ${fc(inv.discount)}</span></div>`
    : ''

  const deliverablesSection = (inv.deliverables || []).length > 0 ? `
    <div style="padding:8px 32px 10px;border-bottom:1px solid #e4e8f4;background:#fff;display:flex;align-items:center;gap:12px;flex-wrap:wrap">
      <div style="font-size:8px;font-weight:700;text-transform:uppercase;letter-spacing:0.16em;color:#4F46E5;white-space:nowrap;flex-shrink:0">Deliverables</div>
      <div style="display:flex;flex-wrap:wrap;gap:5px">
        ${(inv.deliverables || []).map(d =>
          `<span style="font-size:10px;font-weight:500;color:#3c3f8f;background:#eef0ff;border:1px solid #d4d7f5;border-radius:4px;padding:2px 9px">✓ ${d}</span>`
        ).join('')}
      </div>
    </div>` : ''

  const notesSection = inv.notes ? `
    <div style="margin:0 32px 20px">
      <div style="background:#fffdf5;border:1px solid #ede0b8;border-radius:8px;padding:12px 16px">
        <div style="font-size:9px;font-weight:700;color:#b5922a;text-transform:uppercase;letter-spacing:0.12em;margin-bottom:4px">Notes : ${inv.notes}</div>
      </div>
    </div>` : ''

  return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<title>${inv.id} - Netratechnosys Invoice</title>
<style>
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family: 'Segoe UI', Arial, sans-serif; background:#f0f4ff; display:flex; justify-content:center; padding:32px 16px; min-height:100vh; }
  .inv-wrap { width:860px; max-width:100%; }
  @media print {
    body { background:#fff; padding:0; display:block; }
    .inv-wrap { width:100%; max-width:100%; }
    .inv { box-shadow:none !important; border-radius:0 !important; border:none !important; }
    @page { margin:0; size:A4; }
  }
</style>
</head>
<body>
<div class="inv-wrap">
<div class="inv" style="background:#ffffff;border-radius:16px;overflow:hidden;box-shadow:0 8px 48px rgba(0,0,0,0.14);border:1px solid #e4e8f4">

  <!-- Top gradient band -->
  <div style="height:4px;background:linear-gradient(90deg,#4F46E5 0%,#818CF8 40%,#06B6D4 70%,#4F46E5 100%)"></div>

  <!-- Header -->
  <div style="display:grid;grid-template-columns:1fr 1fr;background:#f4f6ff;padding:28px 32px 24px;gap:24px;border-bottom:2px solid #e4e8f4;align-items:flex-start">
    <div>
      <div style="font-size:25px;font-weight:800;color:#0D1530;letter-spacing:0.08em;font-family:'Segoe UI',Arial,sans-serif">NETRA<span style="color:#4F46E5">TECHNOSYS</span>®</div>
      <div style="font-size:9px;color:#6D7AA5;margin-top:4px;letter-spacing:0.14em;text-transform:uppercase">Premium Technology Services</div>
      <div style="margin-top:14px;font-size:11px;color:#6D7AA5;line-height:2">
        hello@netratechnosys.com · +91 0261 4610281<br>
        #606, 6th FL, Laxmi Enclave 2, Opp Gajera School, Katargam,<br>
        Surat, Gujarat, India.
      </div>
    </div>
    <div style="text-align:right;display:flex;flex-direction:column;justify-content:space-between;gap:14px">
      <div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px">
        <div style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.16em;color:#4F46E5">Tax Invoice</div>
        <div style="font-family:'Courier New',monospace;font-size:18px;font-weight:600;color:#0D1530;margin-top:2px">${inv.id}</div>
        ${inv.poNumber ? `<div style="font-size:10px;color:#6D7AA5;margin-top:2px">PO: ${inv.poNumber}</div>` : ''}
        <div style="display:inline-flex;align-items:center;gap:6px;padding:4px 14px;border-radius:99px;font-size:10px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;margin-top:6px;background:${statusBg};color:${statusColor};border:1px solid ${statusColor}55">
          <span style="width:6px;height:6px;border-radius:50%;background:${statusColor};display:inline-block"></span>
          ${statusLabel}
        </div>
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">
        <div style="background:rgba(79,70,229,0.07);border-radius:8px;padding:9px 12px;border:1px solid rgba(79,70,229,0.14);text-align:left">
          <div style="font-size:9px;text-transform:uppercase;letter-spacing:0.1em;color:#6D7AA5;font-weight:600">Issued</div>
          <div style="font-size:12px;font-weight:500;color:#0D1530;margin-top:3px">${inv.date}</div>
        </div>
        <div style="background:rgba(79,70,229,0.07);border-radius:8px;padding:9px 12px;border:1px solid rgba(79,70,229,0.14);text-align:left">
          <div style="font-size:9px;text-transform:uppercase;letter-spacing:0.1em;color:#6D7AA5;font-weight:600">Due Date</div>
          <div style="font-size:12px;font-weight:500;color:#0D1530;margin-top:3px">${inv.due}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Bill To / Project -->
  <div style="display:grid;grid-template-columns:1fr 1fr;border-bottom:1px solid #e4e8f4;background:#ffffff">
    <div style="padding:20px 32px;border-right:1px solid #e4e8f4">
      <div style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.16em;color:#4F46E5;margin-bottom:8px">Bill To</div>
      <div style="font-size:15px;font-weight:700;color:#0D1530;margin-bottom:5px">${inv.client}</div>
      <div style="font-size:12px;color:#3D4A73;line-height:1.9">
        ${inv.clientContact ? inv.clientContact + '<br>' : ''}
        ${inv.clientPhone ? inv.clientPhone + '<br>' : ''}
        ${inv.email}<br>${inv.clientAddress}
      </div>
    </div>
    <div style="padding:20px 32px">
      <div style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.16em;color:#4F46E5;margin-bottom:8px">Project</div>
      <div style="font-size:15px;font-weight:700;color:#0D1530;margin-bottom:5px">${inv.projectName}</div>
      <div style="font-size:12px;color:#3D4A73;line-height:1.9">
        ${inv.projectId} · ${inv.projectCategory}<br>
        PM: ${inv.projectManager}<br>
        ${inv.startDate} → ${inv.endDate}
      </div>
    </div>
  </div>

  <!-- Meta Band (compact, 8 cols) -->
  <div style="display:grid;grid-template-columns:repeat(8,1fr);background:#fafbff;border-bottom:1px solid #e4e8f4">
    ${[['Terms', inv.paymentTerms], ['Currency', inv.currency], ['Mode', inv.paymentMode], ['Bank', inv.bankAccount], ['IFSC', inv.ifsc], ['GST', inv.gstNumber], ['Start', inv.startDate], ['End', inv.endDate]]
      .map(([k, v], i) => `
      <div style="padding:8px 12px;border-right:${i < 7 ? '1px solid #e4e8f4' : 'none'}">
        <div style="font-size:8px;text-transform:uppercase;letter-spacing:0.12em;color:#6D7AA5;font-weight:600">${k}</div>
        <div style="font-size:11px;font-weight:500;color:#0D1530;margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${v || '—'}</div>
      </div>`).join('')}
  </div>

  <!-- Deliverables (inline compact row) -->
  ${deliverablesSection}

  <!-- Line Items -->
  <div style="padding:20px 32px 0;background:#ffffff">
    <div style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.16em;color:#4F46E5;margin-bottom:14px">SERVICES RENDERED</div>
    <table style="width:100%;border-collapse:collapse">
      <thead>
        <tr style="background:#f4f6ff">
          <th style="font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:0.12em;color:#6D7AA5;padding:11px 14px;text-align:left;border-radius:8px 0 0 8px">#</th>
          <th style="font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:0.12em;color:#6D7AA5;padding:11px 14px;text-align:left">Description</th>
          <th style="font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:0.12em;color:#6D7AA5;padding:11px 14px;text-align:right">Qty</th>
          <th style="font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:0.12em;color:#6D7AA5;padding:11px 14px;text-align:right">Rate</th>
          <th style="font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:0.12em;color:#6D7AA5;padding:11px 14px;text-align:right;border-radius:0 8px 8px 0">Amount</th>
        </tr>
      </thead>
      <tbody>${itemRows}</tbody>
    </table>
  </div>

  <!-- Totals -->
  <div style="display:flex;justify-content:flex-end;padding:16px 32px 22px;background:#ffffff">
    <div style="width:290px;background:#f4f6ff;border:1px solid #e4e8f4;border-radius:12px;padding:14px 16px">
      <div style="display:flex;justify-content:space-between;padding:7px 0;font-size:12px;color:#3D4A73;border-bottom:1px solid #e4e8f4">
        <span>Subtotal</span>
        <span style="font-family:'Courier New',monospace;font-weight:500">${fc(inv.amount)}</span>
      </div>
      ${discountRow}
      <div style="display:flex;justify-content:space-between;padding:7px 0;font-size:12px;color:#3D4A73;border-bottom:1px solid #e4e8f4">
        <span>GST (18%)</span>
        <span style="font-family:'Courier New',monospace;font-weight:500">${fc(inv.tax)}</span>
      </div>
      <div style="display:flex;justify-content:space-between;align-items:center;padding:7px 14px;background:#4F46E5;border-radius:8px;margin-top:10px">
        <span style="font-size:13px;font-weight:600;color:rgba(255,255,255,0.9)">Total Due</span>
        <span style="font-family:'Courier New',monospace;font-size:17px;font-weight:700;color:#ffffff">${fc(inv.total)}</span>
      </div>
    </div>
  </div>

  <!-- Notes -->
  ${notesSection}

  <!-- Footer -->
  <div style="display:grid;grid-template-columns:1fr 1fr 1fr;border-top:1px solid #e4e8f4;background:#fafbff">
    <div style="padding:18px 24px;border-right:1px solid #e4e8f4">
      <div style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.16em;color:#4F46E5;margin-bottom:10px">Payment Details</div>
      ${[['Bank', inv.bankAccount], ['IFSC', inv.ifsc], ['Mode', inv.paymentMode]].map(([k, v]) =>
        `<div style="display:flex;gap:8px;font-size:12px;line-height:2.2">
          <span style="color:#6D7AA5;min-width:44px;font-size:11px">${k}</span>
          <span style="color:#0D1530;font-weight:500">${v || '—'}</span>
        </div>`).join('')}
    </div>
    <div style="padding:18px 24px;border-right:1px solid #e4e8f4;text-align:center">
      <div style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.16em;color:#4F46E5;margin-bottom:10px">Authorized Signature</div>
      <div style="display:flex;justify-content:center;margin-bottom:4px">
        <svg width="140" height="48" viewBox="0 0 140 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 36 C14 20,22 14,28 18 C34 22,30 34,36 30 C42 26,44 16,52 20 C58 24,54 36,62 28 C68 22,72 12,80 16 C88 20,84 34,92 26 C98 20,104 14,112 18 C118 22,116 32,124 28 C128 26,130 22,134 20" stroke="#0D1530" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          <path d="M18 38 C26 34,34 38,40 36 C48 34,52 40,60 38" stroke="#0D1530" stroke-width="1.4" stroke-linecap="round" fill="none" opacity="0.4"/>
          <path d="M72 38 C80 35,90 39,98 37 C106 35,112 40,120 38" stroke="#0D1530" stroke-width="1.4" stroke-linecap="round" fill="none" opacity="0.4"/>
        </svg>
      </div>
      <div style="height:1px;background:#e4e8f4;margin:4px 10px 6px"></div>
      <div style="font-size:12px;font-weight:600;color:#0D1530">Rajesh Sharma</div>
      <div style="font-size:11px;color:#6D7AA5">Director, Netratechnosys</div>
    </div>
    <div style="padding:18px 24px">
      <div style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.16em;color:#4F46E5;margin-bottom:10px">Terms & Conditions</div>
      <div style="font-size:12px;color:#3D4A73;line-height:2">
        Payment due within 30 days.<br>
        Late fee: 2% per month.<br>
        Thank you for your business!
      </div>
    </div>
  </div>

  <!-- Bottom Bar -->
  <div style="background:#4F46E5;padding:11px 32px;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:8px">
    <span style="font-size:11px;color:rgba(255,255,255,0.75)">Netratechnosys® · hello@netratechnosys.com · +91 0261 4610281</span>
    <span style="font-family:'Courier New',monospace;font-size:10px;color:#e4e8f4">${inv.id} · Generated ${todayStr}</span>
  </div>

</div>
</div>
</body>
</html>`
}

/* ─── Signature SVG ─── */
const SignatureSVG = () => (
  <svg width="140" height="48" viewBox="0 0 140 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 36 C14 20,22 14,28 18 C34 22,30 34,36 30 C42 26,44 16,52 20 C58 24,54 36,62 28 C68 22,72 12,80 16 C88 20,84 34,92 26 C98 20,104 14,112 18 C118 22,116 32,124 28 C128 26,130 22,134 20"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <path d="M18 38 C26 34,34 38,40 36 C48 34,52 40,60 38"
      stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" fill="none" opacity="0.4" />
    <path d="M72 38 C80 35,90 39,98 37 C106 35,112 40,120 38"
      stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" fill="none" opacity="0.4" />
  </svg>
)

/* ─── React Invoice Template (modal preview) ─── */
function InvoiceTemplate({ inv }) {
  const fc = (n) => formatCurrency(n, inv.currency)
  const sm = STATUS_META[inv.status] || STATUS_META.draft

  return (
    <div className="pinv-root">
      <div className="pinv-top-band" />

      {/* Header */}
      <div className="pinv-header">
        <div className="pinv-header-left">
          <div className="pinv-brand">NETRA<span>TECHNOSYS®</span></div>
          <div className="pinv-brand-sub">Premium Technology Services</div>
          <div className="pinv-brand-contact">
            hello@netratechnosys.com · +91 0261 4610281<br />
            #606, 6th FL, Laxmi Enclave 2, Opp Gajera School, Katargam,<br />
            Surat, Gujarat, India.
          </div>
        </div>
        <div className="pinv-header-right">
          <div className="pinv-tax-col">
            <div className="pinv-gold-label">Tax Invoice</div>
            <div className="pinv-inv-number">{inv.id}</div>
            {inv.poNumber && <div className="pinv-po">PO: {inv.poNumber}</div>}
            <span className={`pinv-status-pill pinv-status-${inv.status}`}>
              <span className="pinv-status-dot" />{sm.label}
            </span>
          </div>
          <div className="pinv-dates-grid">
            <div className="pinv-date-cell">
              <div className="pinv-date-lbl">Issued</div>
              <div className="pinv-date-val">{inv.date}</div>
            </div>
            <div className="pinv-date-cell">
              <div className="pinv-date-lbl">Due Date</div>
              <div className="pinv-date-val">{inv.due}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Bill To / Project */}
      <div className="pinv-parties">
        <div className="pinv-party">
          <div className="pinv-section-label">Bill To</div>
          <div className="pinv-party-name">{inv.client}</div>
          <div className="pinv-party-detail">
            {inv.clientContact && <>{inv.clientContact}<br /></>}
            {inv.clientPhone && <>{inv.clientPhone}<br /></>}
            {inv.email}<br />{inv.clientAddress}
          </div>
        </div>
        <div className="pinv-party pinv-party-right">
          <div className="pinv-section-label">Project</div>
          <div className="pinv-party-name">{inv.projectName}</div>
          <div className="pinv-party-detail">
            {inv.projectId} · {inv.projectCategory}<br />
            PM: {inv.projectManager}<br />
            {inv.startDate} → {inv.endDate}
          </div>
        </div>
      </div>

      {/* Meta Band — compact 8 cols */}
      <div className="pinv-meta-band">
        {[
          ['Terms', inv.paymentTerms], ['Currency', inv.currency],
          ['Mode', inv.paymentMode], ['Bank', inv.bankAccount],
          ['IFSC', inv.ifsc], ['GST', inv.gstNumber],
          ['Start', inv.startDate], ['End', inv.endDate],
        ].map(([k, v]) => (
          <div key={k} className="pinv-meta-item">
            <div className="pinv-meta-key">{k}</div>
            <div className="pinv-meta-val">{v || '—'}</div>
          </div>
        ))}
      </div>

      {/* Deliverables — inline compact row */}
      {(inv.deliverables || []).length > 0 && (
        <div className="pinv-deliverables-row">
          <div className="pinv-del-label">Deliverables</div>
          <div className="pinv-del-tags">
            {(inv.deliverables || []).map((d, i) => (
              <span key={i} className="pinv-deliverable-tag">✓ {d}</span>
            ))}
          </div>
        </div>
      )}

      {/* Line Items */}
      <div className="pinv-table-section">
        <div className="pinv-divider-title">Services Rendered</div>
        <table className="pinv-table">
          <thead>
            <tr>
              {['#', 'Description', 'HR', 'Rate', 'Amount'].map((h, i) => (
                <th key={h} className={i > 1 ? 'r' : ''}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(inv.items || []).map((item, i) => (
              <tr key={i}>
                <td className="pinv-td-num">{i + 1}</td>
                <td className="pinv-td-desc">{item.desc}</td>
                <td className="r mono">{item.qty}</td>
                <td className="r mono">{fc(item.rate)}</td>
                <td className="r mono bold">{fc(item.amount)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Totals */}
      <div className="pinv-totals-wrap">
        <div className="pinv-totals-box">
          {[
            ['Subtotal', fc(inv.amount)],
            ...(inv.discount > 0 ? [['Discount', `− ${fc(inv.discount)}`]] : []),
            ['GST (18%)', fc(inv.tax)],
          ].map(([lbl, val]) => (
            <div key={lbl} className="pinv-total-row">
              <span>{lbl}</span><span>{val}</span>
            </div>
          ))}
          <div className="pinv-grand-row">
            <span>Total Due</span>
            <span className="pinv-grand-val">{fc(inv.total)}</span>
          </div>
        </div>
      </div>

      {/* Notes */}
      {inv.notes && (
        <div className="pinv-notes">
          <div className="pinv-notes-lbl">Notes : {inv.notes}</div>
        </div>
      )}

      {/* Footer */}
      <div className="pinv-footer-cols">
        <div className="pinv-footer-col">
          <div className="pinv-footer-col-lbl">Payment Details</div>
          {[['Bank', inv.bankAccount], ['IFSC', inv.ifsc], ['Mode', inv.paymentMode]].map(([k, v]) => (
            <div key={k} className="pinv-bank-row">
              <span className="pinv-bank-k">{k}</span>
              <span className="pinv-bank-v">{v || '—'}</span>
            </div>
          ))}
        </div>
        <div className="pinv-footer-col pinv-sig-col">
          <div className="pinv-footer-col-lbl">Authorized Signature</div>
          <div className="pinv-sig-svg"><SignatureSVG /></div>
          <div className="pinv-sig-line" />
          <div className="pinv-sig-name">Rajesh Sharma</div>
          <div className="pinv-sig-role">Director, Netratechnosys</div>
        </div>
        <div className="pinv-footer-col pinv-terms-col">
          <div className="pinv-footer-col-lbl">Terms & Conditions</div>
          <div className="pinv-terms-text">
            Payment due within 30 days.<br />
            Late fee: 2% per month.<br />
            Thank you for your business!
          </div>
        </div>
      </div>

      <div className="pinv-bottom-bar">
        <span className="pinv-bottom-l">Netratechnosys® · hello@netratechnosys.com · +91 0261 4610281</span>
        <span className="pinv-bottom-r">{inv.id} · Generated {fmtDate(today())}</span>
      </div>
    </div>
  )
}

export default function Invoice() {
  const [invoices, setInvoices] = useState(INVOICES)
  const [search, setSearch] = useState('')
  const [statusF, setStatusF] = useState('')
  const [createOpen, setCreateOpen] = useState(false)
  const [viewOpen, setViewOpen] = useState(false)
  const [deleteOpen, setDeleteOpen] = useState(false)
  const [active, setActive] = useState(null)
  const [form, setForm] = useState({ id: '', client: '', email: '', amount: '', status: 'draft', due: '', issued: '', notes: '' })

  const filtered = invoices.filter(i =>
    (!search || i.client.toLowerCase().includes(search.toLowerCase()) || i.id.toLowerCase().includes(search.toLowerCase())) &&
    (!statusF || i.status === statusF)
  )

  const stats = [
    { label: 'Total Invoices', value: invoices.length, color: '#4F46E5', glow: 'rgba(79,70,229,.18)', variant: 'indigo', trend: '+18%' },
    { label: 'Paid', value: invoices.filter(i => i.status === 'paid').length, color: '#10B981', glow: 'rgba(16,185,129,.15)', variant: 'green', trend: '+12%' },
    { label: 'Pending', value: invoices.filter(i => i.status === 'pending').length, color: '#F59E0B', glow: 'rgba(245,158,11,.15)', variant: 'amber', trend: '+5%', dir: 'neutral' },
    { label: 'Overdue', value: invoices.filter(i => i.status === 'overdue').length, color: '#EF4444', glow: 'rgba(239,68,68,.15)', variant: 'red', trend: '-3%', dir: 'down' },
  ]

  const openAdd = () => {
    setActive(null)
    setForm({ id: `INV-2025-00${invoices.length + 1}`, client: '', email: '', amount: '', status: 'draft', due: '', issued: today(), notes: '' })
    setCreateOpen(true)
  }
  const openEdit = inv => { setActive(inv); setForm({ ...inv, amount: String(inv.amount) }); setCreateOpen(true) }
  const openView = inv => { setActive(inv); setViewOpen(true) }

  const save = () => {
    if (!form.client.trim() || !form.amount) return
    if (active) {
      setInvoices(p => p.map(i => i.id === active.id ? { ...i, ...form, amount: Number(form.amount) } : i))
    } else {
      setInvoices(p => [{ ...form, amount: Number(form.amount) }, ...p])
    }
    setCreateOpen(false)
  }

  const confirmDelete = () => { setInvoices(p => p.filter(i => i.id !== active.id)); setDeleteOpen(false); setActive(null) }

  const printInvoice = () => {
    if (!active) return
    const html = buildInvoiceHTML(active)
    const old = document.getElementById('__inv_print_frame')
    if (old) old.remove()
    const iframe = document.createElement('iframe')
    iframe.id = '__inv_print_frame'
    iframe.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:960px;height:1px;border:none;visibility:hidden'
    document.body.appendChild(iframe)
    iframe.contentDocument.open()
    iframe.contentDocument.write(html)
    iframe.contentDocument.close()
    setTimeout(() => {
      iframe.style.height = (iframe.contentDocument.body.scrollHeight + 40) + 'px'
      setTimeout(() => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
        setTimeout(() => iframe.remove(), 2000)
      }, 500)
    }, 600)
  }

  const downloadInvoice = async () => {
    if (!active) return
    const loadScript = (src) => new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) { resolve(); return }
      const s = document.createElement('script')
      s.src = src; s.onload = resolve; s.onerror = reject
      document.head.appendChild(s)
    })
    try {
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js')
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js')
      const RENDER_WIDTH = 860
      const iframe = document.createElement('iframe')
      iframe.style.cssText = `position:fixed;left:-9999px;top:0;width:${RENDER_WIDTH}px;border:none;visibility:hidden;z-index:-1`
      document.body.appendChild(iframe)
      const html = buildInvoiceHTML(active)
      iframe.contentDocument.open()
      iframe.contentDocument.write(html)
      iframe.contentDocument.close()
      await new Promise(r => setTimeout(r, 2000))
      const invoiceEl = iframe.contentDocument.querySelector('.inv')
      if (!invoiceEl) { document.body.removeChild(iframe); return }
      const fullH = invoiceEl.scrollHeight
      const fullW = invoiceEl.scrollWidth
      iframe.style.height = (fullH + 60) + 'px'
      await new Promise(r => setTimeout(r, 400))
      const SCALE = 2.5
      const canvas = await window.html2canvas(invoiceEl, {
        scale: SCALE, useCORS: true, allowTaint: true,
        backgroundColor: '#ffffff', width: fullW, height: fullH,
        scrollX: 0, scrollY: 0, windowWidth: RENDER_WIDTH, windowHeight: fullH, logging: false,
      })
      document.body.removeChild(iframe)
      const { jsPDF } = window.jspdf
      const PAGE_W_MM = 210
      const PAGE_H_MM = 297
      const mmPerPx = PAGE_W_MM / canvas.width
      const pageHeightPx = Math.floor(PAGE_H_MM / mmPerPx)
      const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4', compress: true })
      let srcY = 0, pageNum = 0
      while (srcY < canvas.height) {
        if (pageNum > 0) pdf.addPage()
        const sliceHeightPx = Math.min(pageHeightPx, canvas.height - srcY)
        const sliceHeightMm = sliceHeightPx * mmPerPx
        const pageCanvas = document.createElement('canvas')
        pageCanvas.width = canvas.width
        pageCanvas.height = sliceHeightPx
        const ctx = pageCanvas.getContext('2d')
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height)
        ctx.drawImage(canvas, 0, srcY, canvas.width, sliceHeightPx, 0, 0, canvas.width, sliceHeightPx)
        const imgData = pageCanvas.toDataURL('image/jpeg', 0.95)
        pdf.addImage(imgData, 'JPEG', 0, 0, PAGE_W_MM, sliceHeightMm)
        srcY += sliceHeightPx
        pageNum++
      }
      pdf.save(`${active.id}-Invoice.pdf`)
    } catch (err) {
      console.error('PDF generation error:', err)
      const blob = new Blob([buildInvoiceHTML(active)], { type: 'text/html;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url; a.download = `${active.id}-Invoice.html`; a.click()
      setTimeout(() => URL.revokeObjectURL(url), 3000)
    }
  }

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }))

  return (
    <div className="dash-page page-in">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 'var(--space-md)' }}>
        <h1 className="page-title">Invoices</h1>
        <button className="btn btn-primary" onClick={openAdd}><Plus size={14} /> Create Invoice</button>
      </div>

      <div className="stats-grid cols-4">
        {stats.map(s => (
          <div key={s.label} className={`stat-card stat-card--${s.variant}`}>
            <span style={{ position: 'absolute', top: 0, right: 0, width: 110, height: 110, borderRadius: '50%', background: s.glow, filter: 'blur(30px)', transform: 'translate(30%,-30%)', pointerEvents: 'none' }} />
            <div className="stat-card-header">
              <div className="stat-card-icon" style={{ background: s.glow, color: s.color, border: `1px solid ${s.glow}` }}><FileText size={15} strokeWidth={1.8} /></div>
              <span className={`stat-card-trend${s.dir === 'down' ? ' down' : s.dir === 'neutral' ? ' neutral' : ''}`} style={{ color: s.color, background: `${s.color}15`, border: `1px solid ${s.glow}` }}>{s.trend}</span>
            </div>
            <div className="stat-card-value">{s.value}</div>
            <div className="stat-card-label">{s.label}</div>
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg,${s.color}88,transparent)`, borderRadius: '0 0 var(--radius-lg) var(--radius-lg)' }} />
          </div>
        ))}
      </div>

      <div className="card" style={{ padding: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)', padding: 'var(--space-md) var(--space-lg)', borderBottom: '1px solid var(--border)', flexWrap: 'wrap' }}>
          <div style={{ position: 'relative', flex: 1, minWidth: 200 }}>
            <Search size={13} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: 'var(--text3)' }} />
            <input className="input" style={{ paddingLeft: 32 }} placeholder="Search invoices…" value={search} onChange={e => setSearch(e.target.value)} />
          </div>
          <select className="input" style={{ width: 'auto', minWidth: 130 }} value={statusF} onChange={e => setStatusF(e.target.value)}>
            <option value="">All Status</option>
            <option value="paid">Paid</option>
            <option value="pending">Pending</option>
            <option value="overdue">Overdue</option>
            <option value="draft">Draft</option>
          </select>
          <button className="btn btn-outline btn-sm">Export</button>
        </div>
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr><th>Invoice</th><th>Client</th><th>Amount</th><th>Status</th><th>Due Date</th><th>Issued</th><th /></tr>
            </thead>
            <tbody>
              {filtered.map(inv => {
                const sm = STATUS_META[inv.status] || STATUS_META.draft
                return (
                  <tr key={inv.id}>
                    <td><span style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--fs-xs)', color: 'var(--accent-hover)', fontWeight: 600 }}>{inv.id}</span></td>
                    <td>
                      <div style={{ fontWeight: 600, color: 'var(--text1)', fontSize: 'var(--fs-sm)' }}>{inv.client}</div>
                      <div style={{ fontSize: 'var(--fs-xs)', color: 'var(--text3)' }}>{inv.email}</div>
                    </td>
                    <td style={{ fontWeight: 700, color: 'var(--text1)', fontFamily: 'var(--font-mono)', fontSize: 'var(--fs-sm)' }}>{fmt(inv.amount)}</td>
                    <td>
                      <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: 5,
                        padding: '3px 10px', borderRadius: 99, fontSize: 11, fontWeight: 600,
                        background: sm.bg, color: sm.color, border: `1px solid ${sm.border}`
                      }}>
                        <span style={{ width: 5, height: 5, borderRadius: '50%', background: sm.color, display: 'inline-block' }} />
                        {sm.label}
                      </span>
                    </td>
                    <td style={{ color: inv.status === 'overdue' ? 'var(--color-red)' : 'var(--text3)', fontSize: 'var(--fs-xs)' }}>{fmtDate(inv.due)}</td>
                    <td style={{ color: 'var(--text3)', fontSize: 'var(--fs-xs)' }}>{fmtDate(inv.date)}</td>
                    <td>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button className="btn btn-ghost btn-icon" onClick={() => openView(inv)} title="View"><Eye size={14} /></button>
                        <button className="btn btn-ghost btn-icon" onClick={() => openEdit(inv)} title="Edit"><Pencil size={14} /></button>
                        <button className="btn btn-ghost btn-icon" style={{ color: 'var(--color-red)' }} onClick={() => { setActive(inv); setDeleteOpen(true) }} title="Delete"><Trash2 size={14} /></button>
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Create / Edit Modal */}
      <Modal
        open={createOpen}
        title={active ? 'Edit Invoice' : 'Create Invoice'}
        subtitle="Fill in the details to generate an invoice"
        onClose={() => setCreateOpen(false)}
        variant={active ? 'edit' : 'add'}
        footer={<>
          <button className="btn btn-outline" onClick={() => setCreateOpen(false)}>Cancel</button>
          <button className="btn btn-primary" onClick={save}>{active ? 'Update Invoice' : 'Create Invoice'}</button>
        </>}
      >
        <div className="form-grid cols-2">
          <div className="form-field"><label>Invoice #</label><input className="input" placeholder="INV-2025-001" value={form.id} onChange={e => f('id', e.target.value)} /></div>
          <div className="form-field"><label>Status</label>
            <select className="input" value={form.status} onChange={e => f('status', e.target.value)}>
              <option value="draft">Draft</option><option value="pending">Pending</option>
              <option value="paid">Paid</option><option value="overdue">Overdue</option>
            </select>
          </div>
          <div className="form-field"><label>Client Name</label><input className="input" placeholder="Acme Corp" value={form.client} onChange={e => f('client', e.target.value)} /></div>
          <div className="form-field"><label>Client Email</label><input className="input" placeholder="billing@acme.com" value={form.email} onChange={e => f('email', e.target.value)} /></div>
          <div className="form-field"><label>Amount (₹)</label><input className="input" type="number" placeholder="50000" value={form.amount} onChange={e => f('amount', e.target.value)} /></div>
          <div className="form-field"><label>Due Date</label><input className="input" type="date" value={form.due} onChange={e => f('due', e.target.value)} /></div>
          <div className="form-field full"><label>Notes / Description</label><textarea className="input" rows={2} placeholder="Web design & development services…" value={form.notes} onChange={e => f('notes', e.target.value)} /></div>
        </div>
      </Modal>

      {/* View Modal */}
      <Modal
        open={viewOpen}
        title={active?.id || 'Invoice'}
        subtitle="Preview · Print · Download PDF"
        onClose={() => setViewOpen(false)}
        variant="edit"
        footer={<>
          <button className="btn btn-outline" onClick={() => setViewOpen(false)}>Close</button>
          <button className="btn btn-outline" style={{ color: '#818CF8', borderColor: 'rgba(79,70,229,.35)', background: 'rgba(79,70,229,.08)' }} onClick={printInvoice}>
            <Printer size={13} /> Print
          </button>
          <button className="btn btn-primary" onClick={downloadInvoice}>
            <Download size={13} /> Download PDF
          </button>
        </>}
      >
        {active && <InvoiceTemplate inv={active} />}
      </Modal>

      {/* Delete Modal */}
      <ConfirmModal
        open={deleteOpen}
        title="Delete Invoice"
        message={`Remove ${active?.id || 'this invoice'} permanently?`}
        onClose={() => setDeleteOpen(false)}
        onConfirm={confirmDelete}
      />

      <style>{`
        .dash-page { display:flex; flex-direction:column; gap:var(--space-lg); width:100%; }

        .modal-card { width: min(980px, 96vw) !important; }

        /* ── Invoice Template Root ── */
        .pinv-root {
          font-family: 'Segoe UI', 'DM Sans', 'Inter', system-ui, sans-serif;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid var(--border);
          background: var(--bg-surface);
          color: var(--text1);

          /* Shared accent */
          --pinv-accent: var(--accent, #4F46E5);

          /* ── Light mode tokens ── */
         bg:            '#ffffff',
          bgSurface:     '#fafbff',
          bgRaised:      '#f4f6ff',
          bgMeta:        '#fafbff',
          text:          '#0D1530',
          text2:         '#3D4A73',
          text3:         '#6D7AA5',
          border:        '#e4e8f4',
          accent:        '#4F46E5',
          accentMuted:   'rgba(79,70,229,0.10)',
          hdrBg:         '#f4f6ff',
          hdrText:       '#0D1530',
          hdrSub:        '#6D7AA5',
          hdrCellBg:     'rgba(79,70,229,0.07)',
          hdrCellBorder: 'rgba(79,70,229,0.14)',
          notesBg:       '#fffdf5',
          notesBorder:   '#ede0b8',
          notesLbl:      '#b5922a',
          notesText:     '#7a6020',
          totalsBg:      '#f4f6ff',
          totalsBorder:  '#e0e4f4',
          grandBg:       '#1a1a2e',
          grandColor:    'rgba(255,255,255,0.75)',
          grandVal:      '#818CF8',
          tagBg:         '#eef0ff',
          tagColor:      '#4a5580',
          tagBorder:     '#d8dcf0',
          barTrack:      '#e4e8f4',
          bottomBg:      '#1a1a2e',
          bottomL:       'rgba(255,255,255,0.45)',
          bottomR:       'rgba(129,140,248,0.65)',
          sigColor:      '#0D1530',
          tblHeadBg:     '#1a1a2e',
        }

        /* ── Dark mode — auto-inherits from parent [data-theme='dark'] ── */
        [data-theme='dark'] .pinv-root {
           bg:            '#0D1220',
          bgSurface:     '#141D30',
          bgRaised:      '#1a2338',
          bgMeta:        '#141c2e',
          text:          '#EFF2FB',
          text2:         '#8B96B3',
          text3:         '#4A5578',
          border:        'rgba(99,102,241,0.18)',
          accent:        '#6366F1',
          accentMuted:   'rgba(99,102,241,0.15)',
          hdrBg:         '#090d18',
          hdrText:       'rgba(255,255,255,0.92)',
          hdrSub:        'rgba(255,255,255,0.45)',
          hdrCellBg:     'rgba(255,255,255,0.06)',
          hdrCellBorder: 'rgba(255,255,255,0.09)',
          notesBg:       '#1a160a',
          notesBorder:   '#3a2e10',
          notesLbl:      '#d4a840',
          notesText:     '#c9a050',
          totalsBg:      '#141c2e',
          totalsBorder:  '#2a3450',
          grandBg:       '#090d18',
          grandColor:    'rgba(255,255,255,0.75)',
          grandVal:      '#818CF8',
          tagBg:         '#1e2a42',
          tagColor:      '#8b96cc',
          tagBorder:     '#2e3c58',
          barTrack:      '#2a3450',
          bottomBg:      '#090d18',
          bottomL:       'rgba(255,255,255,0.35)',
          bottomR:       'rgba(129,140,248,0.6)',
          sigColor:      '#EFF2FB',
          tblHeadBg:     '#0d1120',
        }

        .pinv-top-band {
          height: 4px;
        background: linear-gradient(90deg, var(--accent,#4F46E5) 0%, #818CF8 40%, #06B6D4 70%, var(--accent,#4F46E5) 100%);
        }

        /* ── Header ── */
        .pinv-header {
          display: grid;
          grid-template-columns: 1fr 1fr;
         background: var(--bg-raised);
          padding: 28px 32px 24px;
          gap: 24px;
          border-bottom: 2px solid var(--border);
          align-items: flex-start;
        }
        .pinv-brand { font-size: 25px; font-weight: 800; color: var(--text1);letter-spacing: 0.08em; white-space: nowrap; }
        .pinv-brand span { color: var(--accent); }
        .pinv-brand-sub { font-size: 9px; color: var(--text2); margin-top: 4px; letter-spacing: 0.14em; text-transform: uppercase; }
        .pinv-brand-contact { margin-top: 14px; font-size: 11px; color: var(--text2); line-height: 2; }

        .pinv-header-right { display: flex; flex-direction: column; justify-content: space-between; gap: 14px; text-align: right; }

        .pinv-tax-col { display: flex; flex-direction: column; align-items: flex-end; gap: 6px; }
        .pinv-gold-label { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.16em; color: var(--accent); }
        .pinv-inv-number { font-family: 'Courier New', monospace; font-size: 18px; font-weight: 600; color: var(--text1); margin-top: 2px; }
        .pinv-po { font-size: 10px; color: var(--text2); margin-top: 2px; }

        .pinv-status-pill {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 4px 14px; border-radius: 99px;
          font-size: 10px; font-weight: 700; letter-spacing: 0.08em;
          text-transform: uppercase; margin-top: 6px;
        }
        .pinv-status-dot { width: 6px; height: 6px; border-radius: 50%; background: currentColor; display: inline-block; }
        .pinv-status-paid    { background:rgba(16,185,129,0.15);  color:#10B981; border:1px solid rgba(16,185,129,0.4); }
        .pinv-status-pending { background:rgba(245,158,11,0.15);  color:#F59E0B; border:1px solid rgba(245,158,11,0.4); }
        .pinv-status-overdue { background:rgba(239,68,68,0.15);   color:#EF4444; border:1px solid rgba(239,68,68,0.4); }
        .pinv-status-draft   { background:rgba(99,102,241,0.15);  color:#6366F1; border:1px solid rgba(99,102,241,0.4); }

        .pinv-dates-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
        .pinv-date-cell {
          background: var(--bg-active, rgba(79,70,229,0.08));
          border-radius: 8px; padding: 9px 12px;
          border: 1px solid var(--border); text-align: left;
        }
        .pinv-date-lbl { font-size: 9px; text-transform: uppercase; letter-spacing: 0.1em; color: var(--text3); }
        .pinv-date-val { font-size: 12px; font-weight: 500; color: var(--text1); margin-top: 3px; }

        /* ── Parties ── */
        .pinv-parties {
          display: grid; grid-template-columns: 1fr 1fr;
          border-bottom: 1px solid var(--border);
          background: var(--bg-surface);
        }
        .pinv-party { padding: 20px 32px; }
        .pinv-party-right { border-left: 1px solid var(--border); }
        .pinv-section-label { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.16em; color: var(--accent); margin-bottom: 8px; }
        .pinv-party-name { font-size: 15px; font-weight: 700; color: var(--text1); margin-bottom: 5px; }
        .pinv-party-detail { font-size: 12px; color: var(--text2); line-height: 1.9; }

        /* ── Meta band — compact 8 cols ── */
        .pinv-meta-band {
          display: grid;
          grid-template-columns: repeat(8, 1fr);
          background: var(--bg-surface);
          border-bottom: 1px solid var(--border);
        }
        .pinv-meta-item { padding: 8px 12px; border-right: 1px solid var(--border); }
        .pinv-meta-item:last-child { border-right: none; }
        .pinv-meta-key { font-size: 8px; text-transform: uppercase; letter-spacing: 0.12em; color: var(--text3); font-weight: 600; }
        .pinv-meta-val { font-size: 11px; font-weight: 500; color: var(--text1); margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

        /* ── Deliverables — inline compact row ── */
        .pinv-deliverables-row {
          padding: 8px 32px 10px;
          border-bottom: 1px solid var(--border);
          background: var(--bg-surface);
          display: flex;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
        }
        .pinv-del-label {
          font-size: 8px; font-weight: 700; text-transform: uppercase;
          letter-spacing: 0.16em; color: var(--accent);
          white-space: nowrap; flex-shrink: 0;
        }
        .pinv-del-tags { display: flex; flex-wrap: wrap; gap: 5px; }
        .pinv-deliverable-tag {
          font-size: 10px; font-weight: 500;
          color: var(--text1); background: var(--bg-surface);
          border: 1px solid var(--border);
          border-radius: 4px; padding: 2px 9px;
        }

        /* ── Table ── */
        .pinv-table-section { padding: 18px 32px 0; background: var(--bg-surface); }
        .pinv-divider-title {
          font-size: 9px; font-weight: 700; text-transform: uppercase;
          letter-spacing: 0.16em; color: var(--accent); margin-bottom: 14px;
        }
        .pinv-table { width: 100%; border-collapse: collapse; }
        .pinv-table thead tr { background: var(--bg-surface); }
        .pinv-table thead th { font-size: 9px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.12em; color: var(--text3); padding: 11px 14px; text-align: left; }
        .pinv-table thead th:first-child { border-radius: 8px 0 0 8px; }
        .pinv-table thead th:last-child  { border-radius: 0 8px 8px 0; text-align: right; }
        .pinv-table thead th.r { text-align: right; }
        .pinv-table tbody td { padding: 12px 14px; font-size: 12.5px; color: var(--text2); border-bottom: 1px solid var(--border); }
        .pinv-table tbody tr:last-child td { border-bottom: none; }
        .pinv-td-num  { color: var(--text3) !important; font-size: 11px !important; width: 32px; }
        .pinv-td-desc { font-weight: 500; color: var(--text1) !important; }
        .pinv-table .r    { text-align: right; }
        .pinv-table .mono { font-family: 'Courier New', monospace; font-size: 11.5px; }
        .pinv-table .bold { font-weight: 700; color: var(--text1) !important; }

        /* ── Totals ── */
       .pinv-totals-wrap {
          display: flex; justify-content: flex-end;
          padding: 14px 32px 20px; background: var(--bg-surface);
        }
        .pinv-totals-box {
          width: 290px; background: var(--bg-raised);
          border: 1px solid var(--border);
          border-radius: 12px; padding: 14px 16px;
        }
        .pinv-total-row {
          display: flex; justify-content: space-between;
          padding: 5px 0; font-size: 12.5px; color: var(--text2);
          border-bottom: 1px solid var(--border);
        }
        .pinv-total-row span:last-child { font-family: 'Courier New', monospace; font-size: 11.5px; font-weight: 500; }
        .pinv-grand-row { display: flex; justify-content: space-between; align-items: center; padding: 7px 14px; background: var(--accent); border-radius: 8px; margin-top: 10px; font-size: 13px; font-weight: 600; color: rgba(255,255,255,0.9); }
        .pinv-grand-val { font-family: 'Courier New', monospace; font-size: 17px; font-weight: 700; color: #ffffff; }

        /* ── Notes ── */
        .pinv-notes { margin: 0 32px 18px; background: var(--bg-raised);border: 1px solid var(--border); border-radius: 8px; padding: 12px 16px; }
        .pinv-notes-lbl { font-size: 9px; font-weight: 700; color: var(--accent,#4F46E5); text-transform: uppercase; letter-spacing: 0.12em; }

        /* ── Footer ── */
        .pinv-footer-cols { display: grid; grid-template-columns: 1fr 1fr 1fr; border-top: 1px solid var(--border); background: var(--bg-surface); }
        .pinv-footer-col { padding: 18px 24px; }
        .pinv-footer-col:not(:last-child) { border-right: 1px solid var(--border); }
        .pinv-footer-col-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.16em; color: var(--accent,#4F46E5);  margin-bottom: 10px; }
        .pinv-bank-row { display: flex; gap: 8px; font-size: 12px; line-height: 2.2; }
        .pinv-bank-k { color: var(--text3); min-width: 44px; font-size: 11px; }
        .pinv-bank-v { color: var(--text1); font-weight: 500; }
        .pinv-sig-col { text-align: center; }
        .pinv-sig-svg { display: flex; justify-content: center; margin-bottom: 4px; color: var(--text1); }
        .pinv-sig-line { height: 1px; background: var(--border); margin: 4px 10px 6px; }
        .pinv-sig-name { font-size: 12px; font-weight: 600; color: var(--text1); }
        .pinv-sig-role { font-size: 11px; color: var(--text3); }
        .pinv-terms-text { font-size: 12px; color: var(--text2); line-height: 2; }

        /* ── Bottom bar ── */
        .pinv-bottom-bar { background: var(--accent); padding: 11px 32px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px; }
        .pinv-bottom-l { font-size: 11px; color: rgba(255,255,255,0.75); }
        .pinv-bottom-r { font-family: 'Courier New', monospace; font-size: 10px; color: #e4e8f4; }

        /* ── Responsive ── */
        @media (max-width: 700px) {
          .pinv-header, .pinv-parties, .pinv-footer-cols { grid-template-columns: 1fr; }
          .pinv-party-right { border-left: none; border-top: 1px solid var(--border); }
          .pinv-meta-band { grid-template-columns: repeat(4, 1fr); }
          .pinv-header-right { text-align: left; }
          .pinv-tax-col { align-items: flex-start; }
          .pinv-table-section { padding: 14px 16px 0; }
          .pinv-parties .pinv-party { padding: 16px 16px; }
          .pinv-totals-wrap { padding: 12px 16px 16px; }
          .pinv-notes { margin: 0 16px 16px; }
          .pinv-footer-col { padding: 14px 16px; }
          .pinv-bottom-bar { padding: 10px 16px; }
          .pinv-deliverables-row { padding: 8px 16px 10px; }
        }
        @media (max-width: 480px) {
          .pinv-meta-band { grid-template-columns: repeat(2, 1fr); }
          .pinv-dates-grid { grid-template-columns: 1fr; }
        }
      `}</style>
    </div>
  )
}